enum PlanType {
    WORKSPACE = 'workspace',
    SEAT = 'seat',
    USER = 'user',
}

export default PlanType;
